var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"title-sub"},_vm._l((_vm.c.sub_title),function(item,i){return _c('div',{key:i},[_c('TemplateTransfer',{attrs:{"index":i,"content":item},on:{"update:content":function($event){return _vm.updateContent($event, _vm.index)}}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }